var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_249:1054)","key":0},[React.createElement("path",{"d":"M28.8008 1.00024L36.8008 9.00024L28.8008 17.0002","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M36.8001 9.00513H6.10352e-05","stroke":"currentColor","strokeWidth":"2","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_249:1054"},React.createElement("rect",{"width":"39","height":"18","fill":"currentColor"})))]);
}

Arrow.defaultProps = {"width":"39","height":"18","viewBox":"0 0 39 18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
